import {initialise} from "./game/gameSlice";
import React, {useState} from "react";
import {useAppDispatch} from "../app/hooks";
import styles from "./GameParameterPicker.module.css";

export default function GameParametersPicker() {
    const dispatch = useAppDispatch();
    const [numberOfValues, setNumberOfValues] = useState(2);
    const [boardSize, setBoardSize] = useState(4);

    return (
        <div className={styles.container}>
            <label htmlFor="number-of-values">Number of values</label>
            <input
                 size={3}
                 type="number"
                 id="number-of-values"
                 value={numberOfValues}
                 onChange={event => {
                    setNumberOfValues(Number(event.target.value));
                }}
            />
            <label htmlFor="board-size">Board size</label>
            <input
                size={4}
                type="number"
                id="board-size"
                value={boardSize}
                onChange={event => {
                    setBoardSize(Number(event.target.value));
                }}
            />
            <button onClick={() => {
                dispatch(initialise({numberOfValues, boardSize}))
            }}>Clear any tiles and start from fresh</button>
        </div>
    );
}